import { render } from "./packageManage.vue?vue&type=template&id=67f715ac&scoped=true"
import script from "./packageManage.vue?vue&type=script&lang=js"
export * from "./packageManage.vue?vue&type=script&lang=js"

import "./packageManage.vue?vue&type=style&index=0&id=67f715ac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67f715ac"

export default script